import { render, staticRenderFns } from "./StoryBoard.vue?vue&type=template&id=35182dc4&scoped=true"
import script from "./StoryBoard.vue?vue&type=script&lang=js"
export * from "./StoryBoard.vue?vue&type=script&lang=js"
import style0 from "./StoryBoard.vue?vue&type=style&index=0&id=35182dc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35182dc4",
  null
  
)

export default component.exports